/**
 * FormEntityDropdown
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../services/router/actions';

// Components
import EntityTypeName from '../EntityTypeName';

// Selectors
import { selectOptions, selectEntityId } from './selectors';

// Styles
import './styles.scss';

interface Props {
    entityTypeId: number;
    updateQueryString: Function;
    entityId?: string | string[];
    options: {
        key: number,
        text: string,
        value: number
    }[];
    resetOnNewGroupCreation?: boolean;
}

export class FormEntityDropdown extends React.Component<Props> {
    handleChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { value: number }
    ) => {
        const { resetOnNewGroupCreation } = this.props;
        this.props.updateQueryString({
            selectedCurrentEntityId: data.value,
            ...(resetOnNewGroupCreation ? { newGroup: undefined } : {})
        });
    };

    render() {
        const { entityId, options, entityTypeId } = this.props;
        return (
            <div className="form-entity-dropdown-container">
                <span className="form-entity-dropdown-title">
                    <EntityTypeName entityTypeId={entityTypeId} />
                    {': '}
                </span>
                <Dropdown
                    className="form-entity-dropdown"
                    selectOnBlur={false}
                    lazyLoad
                    value={entityId}
                    options={options}
                    onChange={this.handleChange}
                    direction="left"
                />
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    entityId: selectEntityId,
    options: selectOptions
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(FormEntityDropdown);
